import React, { useState } from "react";
import "../styles/privacy-style.css";

const PrivacyComponent = () => {
  return (
    <div className="privacy-main">
      <div className="main">
        <span className="h1">五行人 隱私權政策</span>

        <div className="line"></div>

        <span className="h2">Privacy Policy</span>

        <span className="des">
          Last updated: October 29, 2025 This Privacy Policy describes Our
          policies and procedures on the collection, use and disclosure of Your
          information when You use the Service and tells You about Your privacy
          rights and how the law protects You. By using the Service, You agree
          to the collection and use of information in accordance with this
          Privacy Policy.
        </span>

        <div className="line"></div>

        <span className="h2">Interpretation and Definitions</span>

        <span className="h3">Interpretation</span>

        <span className="des">
          Words with capitalized initials have meanings defined under the
          following conditions. The definitions apply whether they appear in
          singular or plural.
        </span>

        <span className="h3">Definitions</span>

        <span className="des">
          For the purposes of this Privacy Policy:<br></br>
          <b>Account</b> : means a unique account created for You to access our
          Service or parts of our Service.<br></br>
          <b>Affiliate</b> : means an entity that controls, is controlled by or
          is under common control with a party, where "control" means ownership
          of 50% or more of the shares, equity interest or other securities
          entitled to vote for election of directors or other managing<br></br>
          <b>Application</b> : refers to 五行人, the software program provided
          by the Company.<br></br>
          <b>Company</b> (“the Company”, “We”, “Us” or “Our”) refers to :
          Leinotek Co., Ltd. 8F.-7, No. 22, Sec. 1, Meicun Rd., West Dist.,
          Taichung City 403015, Taiwan (R.O.C.)..<br></br>
          <b>Country</b> :refers to Taiwan.<br></br>
          <b>Device</b> :means any device that can access the Service such as a
          computer, a cellphone or a digital tablet.<br></br>
          <b>Personal Data</b> : is any information that relates to an
          identified or identifiable individual.<br></br>
          <b>Service</b> : refers to the Application.<br></br>
          <b>Service Provider</b> : means any natural or legal person who
          processes the data on behalf of the Company.<br></br>
          <b>Usage Data</b> : refers to data collected automatically, generated
          by the Service or from the Service infrastructure (for example,
          session duration, diagnostic logs).<br></br>
          <b>You</b> : means the individual accessing or using the Service, or
          the company or legal entity represented by such individual.<br></br>
        </span>

        <div className="line"></div>

        <span className="h2">Collecting and Using Your Personal Data</span>

        <span className="h3">Types of Data Collected</span>
        <span className="h4">Personal Data</span>
        <span className="des">
          While using Our Service, We may ask You to provide Personal Data that
          may be used to contact or identify You. This may include, but is not
          limited to:
        </span>
        <span className="left">
          1.Email address
          <br></br>
          2.Usage Data
        </span>
        <br></br>
        <span className="h4">Usage Data</span>
        <span className="des">
          Usage Data is collected automatically when using the Service. This may
          include:
        </span>
        <span className="left">
          1.IP address
          <br></br>
          2.Device type, operating system, browser type and version
          <br></br>
          3.Pages visited within the Service, date/time of visit, time spent
        </span>
        <br></br>
        <span className="h4">
          Information Collected while Using the Application
        </span>
        <span className="des">
          With Your permission, the Application may request access to:
        </span>
        <span className="left">
          1.Location information
          <br></br>
          2.Camera or photo library (ex: uploading avatar or profile photo)
          <br></br>
          3.Contacts list (if importing contacts)
        </span>

        <br></br>
        <span className="des">
          Permissions can be disabled anytime in device settings.
        </span>

        <div className="line"></div>

        <span className="h3">Facial Data (Biometric Information)</span>
        <span className="des">
          We do NOT collect, store, process, analyze, or share ANY facial
          recognition or biometric data. Photos uploaded by users are treated
          only as image files and are not analyzed for facial features.
        </span>

        <div className="line"></div>

        <span className="h2">Use of Your Personal Data</span>
        <span className="des">
          The Company may use Personal Data for the following purposes:
        </span>

        <span className="left">
          <b>1. To provide and maintain the Service,</b> including monitoring
          usage.<br></br>
          <b>2. To manage Your Account</b> within the Service.<br></br>
          <b>3. To perform a contract,</b> such as subscription or purchase of
          digital services.<br></br>
          <b>4. To contact You, </b> including via email, notifications, or
          messaging.<br></br>
          <b>5. To provide marketing & promotional materials, </b> unless You
          opt out.<br></br>
          <b>6. To manage Your requests</b> to us.<br></br>
          <b>7. For business transfers,</b> such as merger or acquisition.
          <br></br>
          <b>8. For analytics and improvement</b> of services and user
          experience.
          <br></br>
        </span>

        <span className="h3">Sharing Your Personal Information</span>

        <span className="des">
          We may share Your information in the following cases:
        </span>

        <table>
          <tr>
            <td className="head">
              <b>Sharing To</b>
            </td>
            <td className="head">
              <b>Purpose</b>
            </td>
          </tr>
          <tr>
            <td>
              <b>Service Providers</b>
            </td>
            <td>Hosting, analytics, communication services</td>
          </tr>
          <tr>
            <td>
              <b>Business Transfers</b>
            </td>
            <td>Merger, acquisition, restructuring</td>
          </tr>
          <tr>
            <td>
              <b>Affiliates</b>
            </td>
            <td>Internal operations under same company group</td>
          </tr>
          <tr>
            <td>
              <b>Business Partners</b>
            </td>
            <td>Optional promotions or co-branded services</td>
          </tr>
          <tr>
            <td>
              <b>Other Users</b>
            </td>
            <td>If You choose to share content publicly</td>
          </tr>
          <tr>
            <td>
              <b>With Your consent</b>
            </td>
            <td>Any other disclosure authorized by You</td>
          </tr>
        </table>

        <div className="line"></div>

        <span className="h2">Retention of Your Personal Data</span>

        <span className="des">
          We retain Personal Data only as long as necessary to:
        </span>

        <span className="left">
          1. Provide the Service<br></br>
          2. Comply with legal obligations<br></br>
          3. Resolve disputes and enforce agreements<br></br>
        </span>

        <div className="line"></div>

        <span className="h2">Transfer of Your Personal Data</span>

        <span className="des">
          Your data may be processed outside Your jurisdiction. We take
          necessary measures to ensure secure data transfer and protection.
        </span>

        <div className="line"></div>

        <span className="h2">Delete Your Personal Data</span>

        <span className="des">You may delete Personal Data by:</span>

        <span className="left">
          1. Using the in-app delete function (if available), or<br></br>
          2. Contacting us at <b>service.support@leinotek.com</b>
          <br></br>
        </span>

        <span className="des">
          We may retain certain information if legally required.
        </span>

        <div className="line"></div>

        <span className="h2">Disclosure of Your Personal Data</span>

        <span className="h3">Business Transactions</span>

        <span className="des">
          If involved in merger, acquisition, or asset sale, Your Personal Data
          may be transferred. We will notify You beforehand.
        </span>

        <span className="h3">Law Enforcement</span>

        <span className="des">
          We may disclose Your Personal Data when required by law or government
          authority.
        </span>

        <span className="h3">Other Legal Requirements</span>

        <span className="des">We may disclose information to:</span>

        <span className="left">
          1. Comply with legal obligations<br></br>
          2. Protect Company rights or assets<br></br>
          3. Prevent wrongdoing or user abuse<br></br>
          4. Ensure safety of users or public<br></br>
          5. Defend against legal liability<br></br>
        </span>

        <div className="line"></div>

        <span className="h2">Security of Your Personal Data</span>

        <span className="des">
          We use commercially acceptable security methods, but no method of
          transmission or storage is 100% secure.
        </span>

        <div className="line"></div>

        <span className="h2">Children's Privacy</span>

        <span className="des">
          We do not knowingly collect data from children under 13 years old. If
          such data is discovered, it will be deleted immediately.
        </span>

        <div className="line"></div>

        <span className="h2">CSAM (Child Sexual Abuse Material) Policy</span>

        <span className="des">
          We enforce zero tolerance toward CSAM or any illegal content. Detected
          violations will be reported to authorities and removed immediately.
        </span>

        <div className="line"></div>

        <span className="h2">Links to Other Websites</span>

        <span className="des">
          Our Service may contain links to external websites. We are not
          responsible for their content or privacy practices.
        </span>

        <div className="line"></div>

        <span className="h2">Changes to This Privacy Policy</span>

        <span className="des">
          We may update this Privacy Policy from time to time. Updates will be
          posted within the Service, and the “Last updated” date will be revised
          accordingly.
        </span>

        <div className="line"></div>

        <span className="h2">Contact Us</span>

        <span className="des">
          If you have questions about this Privacy Policy, you can contact us:
        </span>

        <span className="left">
          By email: <b>service.support@leinotek.com</b>
        </span>
      </div>
    </div>
  );
};

export default PrivacyComponent;
